import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

// eslint-disable-next-line import/prefer-default-export
export const getDashboardSummary = createAsyncThunk(
  'GET_DASHBOARD_SUMMARY',
  () => axios.get('/users/dashboard_summary.json').then((response) => response.data),
);
